import React from 'react';
import { Newspaper, Mail, User, MessageSquare, AlertTriangle } from 'lucide-react';

/**
 * Компонент для предварительного просмотра результата
 */
const PreviewDisplay = ({ mailtoLink, formData }) => {
  if (!mailtoLink) return null;

  // Форматируем содержимое текста для предпросмотра
  const formatMailtoContent = (text) => {
    if (!text) return '';
    return text.replace(/\\n/g, '\n');
  };

  // Определяем, есть ли подпись
  const hasSignature = formData.addSignature && formData.signature;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-5">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
        <Newspaper className="w-5 h-5 mr-2 text-indigo-500" />
        Предпросмотр письма
      </h3>

      <div className="max-w-full overflow-hidden">
        <div className="bg-gray-100 dark:bg-gray-700 rounded-t-lg p-3 border border-gray-200 dark:border-gray-600">
          <div className="flex items-center mb-3">
            <Mail className="w-5 h-5 text-indigo-500 mr-2" />
            <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
              Новое письмо
            </div>
          </div>

          <div className="space-y-2 text-sm">
            <div className="flex">
              <span className="text-gray-600 dark:text-gray-400 w-16">Кому:</span>
              <span className="text-gray-800 dark:text-gray-200 font-medium">{formData.to}</span>
            </div>
            
            {formData.cc && (
              <div className="flex">
                <span className="text-gray-600 dark:text-gray-400 w-16">Копия:</span>
                <span className="text-gray-800 dark:text-gray-200">{formData.cc}</span>
              </div>
            )}
            
            {formData.bcc && (
              <div className="flex">
                <span className="text-gray-600 dark:text-gray-400 w-16">Скрытая:</span>
                <span className="text-gray-800 dark:text-gray-200">{formData.bcc}</span>
              </div>
            )}
            
            <div className="flex">
              <span className="text-gray-600 dark:text-gray-400 w-16">Тема:</span>
              <span className="text-gray-800 dark:text-gray-200 font-medium">{formData.subject || '(без темы)'}</span>
            </div>
          </div>
        </div>

        <div className="p-4 border-x border-b border-gray-200 dark:border-gray-600 rounded-b-lg min-h-[150px] text-sm">
          <div className="whitespace-pre-line text-gray-800 dark:text-gray-200">
            {formatMailtoContent(formData.body)}
            
            {hasSignature && (
              <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300">
                -- <br />
                {formatMailtoContent(formData.signature)}
                {formData.companyName && <div>{formData.companyName}</div>}
                {formData.companyPhone && <div>{formData.companyPhone}</div>}
                {formData.companyWebsite && <div>{formData.companyWebsite}</div>}
              </div>
            )}
          </div>
          
          {/* Блок отслеживания */}
          {formData.useUtmParameters && formData.utmCampaign && (
            <div className="mt-4 pt-2 border-t border-gray-200 dark:border-gray-600 text-gray-500 dark:text-gray-400 text-xs">
              UTM: {`utm_source=${formData.utmSource}&utm_medium=${formData.utmMedium}&utm_campaign=${formData.utmCampaign}`}
            </div>
          )}
          
          {formData.includeGoogleAnalytics && formData.trackOpens && (
            <div className="mt-1 text-gray-500 dark:text-gray-400 text-xs flex items-center">
              <AlertTriangle className="w-3 h-3 mr-1" />
              Pixel отслеживания GA: {formData.gaTrackingId}
            </div>
          )}
        </div>
      </div>

      <div className="mt-3 text-sm text-gray-600 dark:text-gray-400">
        <p className="flex items-center">
          <MessageSquare className="w-4 h-4 mr-1 text-indigo-400" />
          Так будет выглядеть письмо после клика по ссылке.
        </p>
      </div>
    </div>
  );
};

export default PreviewDisplay;